import React from 'react';
import { Box } from '@hover/blueprint';
import TrustedContent from './TrustedContent';
import { TrustedByNamesSlide } from '../../common';

const TrustedByNameTablet: React.FC = () => (
  <Box
    w="100%"
    d={{ base: 'none', tablet: 'flex', desktop: 'none' }}
    flexDir="column"
    alignItems="center"
    pb={800}
    pt={1100}
  >
    <TrustedContent />
    <Box mt={800} w="725px" h="480px">
      <TrustedByNamesSlide />
    </Box>
  </Box>
);

export default TrustedByNameTablet;
